import apiClient from '@u/apiClient'
import apiClientScreen from '@u/apiClientScreen'
import AuthenticateController from '@/wayfinder/actions/App/Http/Controllers/Screen/AuthenticateController'
import GetScreenByIdController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenByIdController'
import GetScreenConfigController from '@/wayfinder/actions/App/Http/Controllers/Screen/GetScreenConfigController'

export default {
  authenticate({ commit, getters }, payload) {
    return new Promise((resolve, reject) => {
      apiClientScreen
        .route(AuthenticateController.post(), {
          access_code: payload.access_code
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  setScreenId({ commit }, payload) {
    commit('setScreenId', {
      screen_id: payload.screen_id
    })
  },
  getScreenById({ commit, getters }, payload) {
    return new Promise((resolve, reject) => {
      apiClientScreen
        .route(
          GetScreenByIdController['/api/screen/{screen}'].get({
            screen: payload.screen_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  getScreenConfig({ commit, getters }, payload) {
    return new Promise((resolve, reject) => {
      apiClientScreen
        .route(GetScreenConfigController.get({ screen: payload.screen_id }))
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
